import React, { FC } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { PrivateRoute } from 'routes/PrivateRoute';
import { Profile } from 'features/Profile/Profile';
import { AppMenuDrawer } from 'components/AppMenu/AppMenuDrawer';
import { SimpleNavBar } from 'components/NavBar/SimpleNavBar';
import { SwitchCatchNotFound as Switch } from './SwitchCatchNotFound';

const ProfileRoutes: FC<{}> = () => {
  const { path } = useRouteMatch();
  return (
    <>
      <AppMenuDrawer />
      <Switch>
        <PrivateRoute exact path={path} component={Profile} navbar={SimpleNavBar} navbarTitle="Profile" />
      </Switch>
    </>
  );
};

export { ProfileRoutes };
